__turbopack_context__.v({
  "link": "BoardSectionItemBavariaMap-module-scss-module__SIt4qG__link",
  "selected": "BoardSectionItemBavariaMap-module-scss-module__SIt4qG__selected",
  "shape": "BoardSectionItemBavariaMap-module-scss-module__SIt4qG__shape",
  "title": "BoardSectionItemBavariaMap-module-scss-module__SIt4qG__title",
});
